import React, { useMemo } from 'react';
import { ArrowDraft, ConnectorPosition } from '@/stores/arrowStore';
import { Item } from '@/stores/canvasStore';
import { getConnectorPoint } from './arrowGeometry';

interface ArrowDraftPathProps {
  draft: ArrowDraft;
  items: Item[];
}

export function ArrowDraftPath({ draft, items }: ArrowDraftPathProps) {
  const pathData = useMemo(() => {
    // Get start point
    let start: { x: number; y: number };
    if (draft.startItemId && draft.startConnector) {
      const startItem = items.find(i => i.id === draft.startItemId);
      if (!startItem) return null;
      start = getConnectorPoint(startItem, draft.startConnector);
    } else {
      start = { x: draft.startX, y: draft.startY };
    }
    
    const end = { x: draft.endX, y: draft.endY };
    
    // Simple straight line for draft
    return {
      start,
      end,
      path: `M ${start.x} ${start.y} L ${end.x} ${end.y}`,
    };
  }, [draft, items]);
  
  if (!pathData) return null;
  
  const { end, path } = pathData;
  
  // Calculate angle for arrowhead
  const angle = Math.atan2(
    pathData.end.y - pathData.start.y,
    pathData.end.x - pathData.start.x
  ) * (180 / Math.PI);
  
  return (
    <g className="arrow-draft">
      {/* Dashed line while drawing */}
      <path
        d={path}
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth={2}
        strokeDasharray="6,4"
        strokeLinecap="round"
      />
      
      {/* Arrowhead preview */}
      <polygon
        points="-8,-5 0,0 -8,5"
        fill="hsl(var(--primary))"
        transform={`translate(${end.x}, ${end.y}) rotate(${angle})`}
      />
    </g>
  );
}
